import { selectCookieBanner } from '@/redux/cookieBanner/cookieBanner.selector';
import { acceptCookies, showBanner } from '@/redux/cookieBanner/cookieBanner.slice';
import { useAppDispatch } from '@/redux/hooks/useAppDispatch';
import { useAppSelector } from '@/redux/hooks/useAppSelector';
import { Button } from '@/shared/Button';
import Link from 'next/link';
import { useEffect } from 'react';
import { cookiePolicyUrlSelector } from '@/redux/configuration/configuration.selectors';
import {
  USER_ACCEPTED_COOKIES_COOKIE_NAME,
  USER_ACCEPTED_COOKIES_COOKIE_VALUE,
} from './CookieBanner.constants';

export const CookieBanner = (): React.ReactNode => {
  const dispatch = useAppDispatch();
  const { visible, accepted } = useAppSelector(selectCookieBanner);
  const cookiePolicyUrl = useAppSelector(cookiePolicyUrlSelector);

  useEffect(() => {
    const isAccepted =
      localStorage.getItem(USER_ACCEPTED_COOKIES_COOKIE_NAME) ===
      USER_ACCEPTED_COOKIES_COOKIE_VALUE.ACCEPTED;
    if (isAccepted) {
      dispatch(acceptCookies());
    } else {
      dispatch(showBanner());
    }
  }, [dispatch]);

  const handleAcceptCookies = (): void => {
    dispatch(acceptCookies());
    localStorage.setItem(
      USER_ACCEPTED_COOKIES_COOKIE_NAME,
      USER_ACCEPTED_COOKIES_COOKIE_VALUE.ACCEPTED,
    );
  };

  if (!visible || accepted || !cookiePolicyUrl) {
    return null;
  }

  return (
    <div className="absolute bottom-8 left-1/2 z-10 -translate-x-1/2 rounded-lg bg-white p-6 drop-shadow">
      <h4 className="text-2xl font-bold">We use cookies!</h4>
      <p className="my-4 leading-loose">
        Minerva platform uses essential cookies to ensure its proper operation. For any queries in
        relation to our policy on cookies and your choices, please{' '}
        <Link href={cookiePolicyUrl} className="font-semibold text-[#1C00DE]">
          read here
        </Link>
      </p>
      <Button
        className="h-10 w-36 justify-center"
        onClick={handleAcceptCookies}
        aria-label="accept cookies"
      >
        Ok
      </Button>
    </div>
  );
};
